import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Select as SelectCmp } from 'tdesign-react';
import { find } from 'lodash';
import { toTsOptions } from '@/utils/common';
import SvgIcon from '@/components/SvgIcon';

export default function EnvSelect({ value, onChange, options }) {
  const onlyOneEnv = useMemo(() => {
    return (options || []).length <= 1;
  }, [options]);

  const currentEnvName = useMemo(() => {
    return find(options || [], { value })?.label;
  }, [options, value]);

  return onlyOneEnv ? (
    <EnvRoot>
      <SvgIcon type='computer-env' /> <EnvText>{currentEnvName}</EnvText>
    </EnvRoot>
  ) : (
    <Select
      prefixIcon={<SvgIcon type='computer-env' />}
      placeholder='选择环境'
      autoWidth
      clearable
      value={value}
      onChange={onChange}
      options={toTsOptions(options)}
    />
  );
}

const EnvRoot = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  gap: 4px;
`;

const EnvText = styled.div`
  font-weight: bold;
  color: var(--td-brand-color-7);
  font-size: 14px;
`;

const Select = styled(SelectCmp)`
  margin-left: 20px;
  .t-input {
    border: 1px solid rgba(25, 77, 255, 0.1);
    border-radius: 20px;
    padding: 0 16px;
    background-color: transparent;
    .t-input__inner {
      color: var(--td-brand-color-7);
      font-weight: bold;
    }
    .t-input__prefix {
      margin-right: var(--td-comp-margin-xs);
    }
  }
`;
